<template>
  <div class="VyInformation">
    <div class="vy-description">
      <span class="vy-info">
        <Svgicon iconName="information"></Svgicon>
        {{ props.promptText }}
      </span>
      <span class="vy-text">{{ props.text }}</span>
    </div>
  </div>
</template>
<script lang="ts" setup>
  import { defineProps } from 'vue';
  import Svgicon from '../components/svgicon.vue';

  const props = defineProps<{
    promptText: string;
    text: string;
  }>();
</script>
